import script from "./Input.vue?vue&type=script&lang=ts&setup=true"
export * from "./Input.vue?vue&type=script&lang=ts&setup=true"

import "./Input.vue?vue&type=style&index=0&id=d98490ca&lang=postcss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d98490ca"]])

export default __exports__